<template>
  <div>
    <OrganisationGouvernanceComp v-bind:mobile="mobile" />
  </div>
</template>

<script>
import OrganisationGouvernanceComp from '@/components/desktop/vitaeSportSante/OrganisationGouvernanceComp'

  export default {
    name: 'OrganisationGouvernance',
    props: ['mobile'],
    components: {
      OrganisationGouvernanceComp
    },
  }
</script>
